export default "__VITE_ASSET__CeK$796l__"